import React from 'react';
import { AvatarImage, Picture } from 'components/common';
import { getMainImageSrcForObj } from 'utilities';
import Draggable from 'react-draggable';
import { inject } from 'mobx-react';
import { EDITOR_MONITOR_STORE, getEntityClass } from 'store';
import { observer } from 'mobx-react-lite';
import BasicItemListView from 'components/editor/Library/BasicItemListView';
import { ItemProps } from './types';

const Item = (props: ItemProps) => {
  const {
    item,
    scrollTop,
    [EDITOR_MONITOR_STORE]: {
      updateLibraryEntityDraggingInfo,
      getShotsCountForEntity
    },
    entityId = item.id,
    entityClass = getEntityClass(item),
    shotsCount = getShotsCountForEntity(item)
  } = props;

  const getPicture = () => {
    const isProduct = entityClass === 'Product';
    return isProduct
      ? <Picture
        size={35}
        src={getMainImageSrcForObj(item)}
      // className={styles.productPicture}
      />
      : <AvatarImage
        size={35}
        src={getMainImageSrcForObj(item)}
        alt={item.name}
      />;
  };

  const [dimensions, setDimensions] = React.useState({ width: 'inherit', height: 'inherit' });
  const onContainerLoad = e => {
    const { clientWidth, clientHeight } = e.currentTarget;
    const width: any = clientWidth - 30;
    const height: any = clientHeight - 5;
    setDimensions({
      width,
      height
    });
  };

  const initialPosition = { x: 0, y: 0 };
  const [controlledPosition, setControlledPosition] = React.useState(initialPosition);

  const onDrag = (e, position) => {
    const { clientX, clientY } = e;
    updateLibraryEntityDraggingInfo({
      clientX,
      clientY,
      entityId,
      entityClass,
      state: 'dragging'
    });
    // console.log('position', position);
    const { x, y } = position;
    setControlledPosition({ x, y });
  };

  const onStop = e => {
    const { clientX, clientY } = e;
    updateLibraryEntityDraggingInfo({
      clientX,
      clientY,
      entityId,
      entityClass,
      state: 'dropped'
    });
    setControlledPosition(initialPosition);
  };

  const isDragging = () => {
    return JSON.stringify(controlledPosition) !== JSON.stringify(initialPosition);
  };

  return (
    <BasicItemListView
      onContainerLoad={onContainerLoad}
      name={item.name}
      pictureComponent={getPicture()}
      shotsCount={shotsCount}
      entityId={entityId}
      entityClass={entityClass}
    >
      <Draggable
        onStart={e => e.preventDefault()}
        onStop={onStop}
        position={controlledPosition}
        onDrag={onDrag}
        // onMouseDown={e => e.stopPropagation()}
        enableUserSelectHack={false}
      >
        <div
          className='box'
          style={{
            // border: '1px solid',
            position: 'absolute',
            ...dimensions,
            // bottom: '100px',
            // right: '100px',
            zIndex: 999,
            marginTop: -scrollTop
          }}
        >
          {isDragging() && getPicture()}
        </div>
      </Draggable>

    </BasicItemListView>
  );
};

export default inject(EDITOR_MONITOR_STORE)(observer(Item));
